import { inject, Injectable } from '@angular/core';
import {PreInitSettingsService} from './settings';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError, throwError} from 'rxjs';
import { EquipmentRequest } from '../../model/plan/plan-detail';

@Injectable({
  providedIn: 'root',
})
export class RegisteredEquipmentService {
  middlewareUrl: string;
  accountPath: string;

  preInitSettingsService = inject(PreInitSettingsService);
  http = inject(HttpClient);

  constructor() {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
  }

  addEquipment(equipment: EquipmentRequest): Observable<any> {
    return this.http.post<any>(`${this.middlewareUrl}${this.accountPath}registered-equipment/create`, equipment);
  }

  updateEquipment(equipment: EquipmentRequest): Observable<unknown> {
    return this.http.put<unknown>(`${this.middlewareUrl}${this.accountPath}registered-equipment/update`, equipment).pipe(
      catchError((err) => {
        console.error('Error updating equipment:', err);
        return throwError(() => err);
      })
    );
  }
}
